import { DateInput as AriaDateInput, DateSegment as AriaDateSegment } from "react-aria-components";

import { cn } from "../../utils/cn";

import type { DateInputProps as AriaDateInputProps } from "react-aria-components";

export const DateInput = (props: Omit<AriaDateInputProps, "children">) => {
  return (
    <AriaDateInput
      {...props}
      className={cn(
        "flex-1 rounded-sm border border-solid border-field px-3 py-1",
        "bg-white dark:bg-gray-800",
        "dark:border-gray-700",
        "focus-within:border-field-selected focus-within:ring-2 focus-within:ring-blue-100",
        "dark:focus-within:border-blue-600 dark:focus-within:ring-blue-900",

        typeof props.className === "string" && props.className
      )}
    >
      {segment => (
        <AriaDateSegment
          segment={segment}
          className={cn(
            "outline-hidden caret-auto px-0.5 tabular-nums",
            "text-gray-900 dark:text-gray-100",
            "data-[placeholder]:text-gray-400 dark:data-[placeholder]:text-gray-500"
          )}
        >
          {({ isPlaceholder, type, text }) => {
            if (isPlaceholder) {
              if (type === "month") return "MM";
              if (type === "day") return "DD";
              if (type === "year") return "YYYY";
              if (type === "hour") return "HH";
              if (type === "minute") return "MM";
            }
            return text;
          }}
        </AriaDateSegment>
      )}
    </AriaDateInput>
  );
};
